module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-live"
  }, [(_vm.showTop) ? _c('div', {
    staticClass: "title"
  }, [_c('span', {
    style: ({
      color: _vm.color
    })
  }, [_vm._v(_vm._s(_vm.$t("message.live")))]), _vm._v(" "), _c('span', {
    staticClass: "right more",
    style: ({
      color: _vm.color
    }),
    on: {
      "click": _vm.more
    }
  }, [_vm._v(_vm._s(_vm.$t("message.more")) + " 》")])]) : _vm._e(), _vm._v(" "), _c('ul', {
    class: {
      'list-con': _vm.padding
    },
    staticStyle: {
      "height": "650px",
      "overflow-y": "auto"
    }
  }, _vm._l((_vm.lives), function(item, i) {
    return _c('li', {
      key: i,
      staticClass: "live-item",
      style: ({
        width: _vm.width + 'px'
      }),
      on: {
        "click": function($event) {
          _vm.goLive(item)
        }
      }
    }, [_c('div', {
      staticClass: "img",
      style: ({
        backgroundImage: ("url(" + (item.imgUrl) + ")")
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "con"
    }, [_c('h2', [_vm._v(_vm._s(item.liveTitle ? item.liveTitle : '暂无标题'))]), _vm._v(" "), _c('p', {
      staticClass: "time"
    }, [_c('span', {
      staticClass: "left"
    }, [_vm._v(_vm._s(_vm._f("formatDt")(item.liveStartDt)))]), _c('span', {
      staticClass: "right"
    }, [_vm._v(_vm._s(item.liveDt))])])]), _vm._v(" "), _c('div', {
      staticClass: "count"
    }, [_c('div', {
      staticClass: "left"
    }, [_c('img', {
      staticClass: "img-item",
      attrs: {
        "src": require("../../common/imgs/play.svg"),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.liveViewNum) + " " + _vm._s(_vm.$t("message.times")))])]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('img', {
      staticClass: "img-item",
      attrs: {
        "src": require("../../common/imgs/edit.svg"),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.liveComtNum))])])])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e968dda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/livecom/livecom.vue
// module id = 785
// module chunks = 10